// import React, { useState, useEffect, useRef, useCallback } from 'react';
import React, { Component } from 'react';
import './App.css';
import { initMapZoom } from '../d3/drawMap';
import europeMap from '../europe-map.svg';
import drawMap from '../d3/drawMap.js';
import Clock from '../components/Clock.js';
import Navigation from '../components/Navigation.js';
import Thankyou from '../components/Thankyou.js';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1
    };
    this.svgContentRef = React.createRef();
    this.svgContainerRef = React.createRef();
  }

  // componentDidMount() {
  //   this.loadSvg();
  // }

  // componentWillUnmount() {
  //   if (this.cleanupZoom) {
  //     this.cleanupZoom();
  //   }
  // }


  componentDidMount() {
    this.loadSvg();
    this.fetchData()
    this.fetchDataChart()
    this.interval = setInterval(() => {
      this.fetchData()
    }, 10000);
    this.interval2 = setInterval(() => {
      this.fetchDataChart()
    }, 300000);
  }

  fetchData() {
    fetch('/new_site/api/AllData')
      .then((response) => response.json())
      .then((data) => this.setState({ data: data }))
  }
  fetchDataChart() {
    fetch('/new_site/api/Flows')
      .then((response) => response.json())
      .then((data) => this.setState({ flows: data }))
  }


  componentWillUnmount() {
    clearInterval(this.interval);
    if (this.cleanupZoom) {
      this.cleanupZoom();
    }
  }



  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) {
      drawMap(this.state.data, this.state.flows);
    }
  }

  loadSvg = async () => {
    try {
      const response = await fetch(europeMap);
      const svgText = await response.text();

      if (this.svgContentRef.current) {
        this.svgContentRef.current.innerHTML = svgText;
        const svgElement = this.svgContentRef.current.querySelector('svg');

        if (svgElement) {
          svgElement.setAttribute('width', '100%');
          svgElement.setAttribute('height', '100%');
          svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');

          this.cleanupZoom = initMapZoom({
            svgContent: this.svgContentRef.current,
            container: this.svgContainerRef.current,
            onScaleChange: this.handleScaleChange
          });
        }
      }
    } catch (error) {
      console.error('Error loading SVG:', error);
      if (this.svgContentRef.current) {
        this.svgContentRef.current.innerHTML = '<p>Error loading Europe map</p>';
      }
    }
  };

  handleScaleChange = (newScale) => {
    this.setState({ scale: newScale });
  };

  render() {
    return (
      <div className="container">
        <Navigation />
        <div className="svg-container" ref={this.svgContainerRef}>
          <div id="svg-content" ref={this.svgContentRef} />

          <div
            id="svg-tooltip"
            style={{
              position: 'absolute',
              display: 'none',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              color: 'white',
              padding: '8px 12px',
              borderRadius: '4px',
              pointerEvents: 'none',
              zIndex: 1000
            }}
          ></div>

        </div>
        <div className='scale'>Current scale: {this.state.scale.toFixed(2)} (Ctrl+Scroll to zoom)</div>
        <Clock />
        <Thankyou />
      </div>
    );
  }
}

export default App;